/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/*
query BaselineEditPageQuery(
  $projectId: String
) {
  viewer {
    actualPersonId
    component(name: "edit_baseline")
    project(id: $projectId) {
      id
    }
    ...BaselineEditPage_viewer_2CgS8h
    id
  }
}

fragment BaselineEditPage_viewer_2CgS8h on Viewer {
  id
  company {
    id
    name
    currency
    roles {
      edges {
        node {
          id
          name
        }
      }
    }
    expenseCategories {
      edges {
        node {
          id
          name
          disabled
        }
      }
    }
  }
  project(id: $projectId) {
    ...ProjectIndicator_project
    useBaseline
    useDeliverables
    budgetType
    budget
    id
    status
    companyProjectId
    customProjectId
    projectColor
    name
    baselineEstimationMinutesPerDay
    projectStartYear
    projectStartMonth
    projectStartDay
    projectEndYear
    projectEndMonth
    projectEndDay
    baselineTargetMinutes
    baselineTarget
    baselineCost
    baselineProfit
    baselineAdjustPercentage
    baselineAdjustPrice
    baselineTargetPrice
    useFixedPriceForBaselineRevenue
    rateCard {
      id
      currency
      disabledRoles {
        id
      }
      rates {
        edges {
          node {
            rate
            defaultRate
            role {
              id
            }
            id
          }
        }
      }
    }
    financialNumbers(convertToProjectCurrency: true) {
      baselineMinutes
      baselineRevenue
      baselineTimeAndExpenses
      baselineCost
      baselineProfit
      baselineMargin
    }
    deliverables(first: 1000000) {
      edges {
        node {
          id
          name
          description
          projectId
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    phases(first: 1000000) {
      edges {
        node {
          id
          name
          startYear
          startMonth
          startDay
          deadlineDay
          deadlineMonth
          deadlineYear
          projectId
          averageRatesByRole {
            roleId
            costRate
            rate
          }
          phaseDeliverables(first: 10000) {
            edges {
              node {
                id
                phaseId
                deliverable {
                  id
                  name
                }
                financialNumbers(convertToProjectCurrency: true) {
                  baselineMinutes
                  baselineTimeAndExpenses
                  baselineRevenue
                  baselineCost
                  baselineProfit
                  baselineMargin
                }
                __typename
              }
              cursor
            }
            pageInfo {
              endCursor
              hasNextPage
            }
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    phaseBaselineExpenses(first: 1000000) {
      edges {
        node {
          id
          expenseName
          expenseCategory {
            name
            id
          }
          expenseRevenue
          expenseCost
          expenseMarkup
          expenseProfit
          globalPhaseId
          deliverableId
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    phaseBaselineRoles(first: 1000000) {
      edges {
        node {
          id
          globalPhaseId
          deliverableId
          role {
            name
            id
          }
          financialNumbers(convertToProjectCurrency: true) {
            baselineMinutes
            baselineTimeAndExpenses
            baselineRevenue
            baselineCost
            baselineProfit
            baselineRatePerHour
            baselineCostPerHour
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}

fragment ProjectIndicator_project on ProjectType {
  name
  companyProjectId
  customProjectId
  projectColor
}
*/
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId",
            "type": "String"
        }
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actualPersonId",
        "storageKey": null
    }, v2 = {
        "alias": null,
        "args": [
            {
                "kind": "Literal",
                "name": "name",
                "value": "edit_baseline"
            }
        ],
        "kind": "ScalarField",
        "name": "component",
        "storageKey": "component(name:\"edit_baseline\")"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectId"
        }
    ], v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v5 = [
        (v4 /*: any*/)
    ], v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "baselineCost",
        "storageKey": null
    }, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "baselineProfit",
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rate",
        "storageKey": null
    }, v11 = [
        {
            "kind": "Literal",
            "name": "convertToProjectCurrency",
            "value": true
        }
    ], v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "baselineMinutes",
        "storageKey": null
    }, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "baselineRevenue",
        "storageKey": null
    }, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "baselineTimeAndExpenses",
        "storageKey": null
    }, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "baselineMargin",
        "storageKey": null
    }, v16 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        }
    ], v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectId",
        "storageKey": null
    }, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    }, v20 = {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v21 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10000
        }
    ], v22 = [
        (v4 /*: any*/),
        (v6 /*: any*/)
    ], v23 = [
        (v6 /*: any*/),
        (v4 /*: any*/)
    ], v24 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "globalPhaseId",
        "storageKey": null
    }, v25 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deliverableId",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "BaselineEditPageQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        (v2 /*: any*/),
                        {
                            "alias": null,
                            "args": (v3 /*: any*/),
                            "concreteType": "ProjectType",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": (v5 /*: any*/),
                            "storageKey": null
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "projectId",
                                    "variableName": "projectId"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "BaselineEditPage_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "BaselineEditPageQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        (v2 /*: any*/),
                        {
                            "alias": null,
                            "args": (v3 /*: any*/),
                            "concreteType": "ProjectType",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/),
                                (v6 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "companyProjectId",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "customProjectId",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "projectColor",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "useBaseline",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "useDeliverables",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "budgetType",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "budget",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "status",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "baselineEstimationMinutesPerDay",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "projectStartYear",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "projectStartMonth",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "projectStartDay",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "projectEndYear",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "projectEndMonth",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "projectEndDay",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "baselineTargetMinutes",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "baselineTarget",
                                    "storageKey": null
                                },
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "baselineAdjustPercentage",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "baselineAdjustPrice",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "baselineTargetPrice",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "useFixedPriceForBaselineRevenue",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RateCard",
                                    "kind": "LinkedField",
                                    "name": "rateCard",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        (v9 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Role",
                                            "kind": "LinkedField",
                                            "name": "disabledRoles",
                                            "plural": true,
                                            "selections": (v5 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RateTypeConnection",
                                            "kind": "LinkedField",
                                            "name": "rates",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "RateTypeEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Rate",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                (v10 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "defaultRate",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Role",
                                                                    "kind": "LinkedField",
                                                                    "name": "role",
                                                                    "plural": false,
                                                                    "selections": (v5 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                (v4 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v11 /*: any*/),
                                    "concreteType": "FinancialNumbers",
                                    "kind": "LinkedField",
                                    "name": "financialNumbers",
                                    "plural": false,
                                    "selections": [
                                        (v12 /*: any*/),
                                        (v13 /*: any*/),
                                        (v14 /*: any*/),
                                        (v7 /*: any*/),
                                        (v8 /*: any*/),
                                        (v15 /*: any*/)
                                    ],
                                    "storageKey": "financialNumbers(convertToProjectCurrency:true)"
                                },
                                {
                                    "alias": null,
                                    "args": (v16 /*: any*/),
                                    "concreteType": "DeliverableTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "deliverables",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "DeliverableTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DeliverableType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v6 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "description",
                                                            "storageKey": null
                                                        },
                                                        (v17 /*: any*/),
                                                        (v18 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v19 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v20 /*: any*/)
                                    ],
                                    "storageKey": "deliverables(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v16 /*: any*/),
                                    "filters": [],
                                    "handle": "connection",
                                    "key": "Project_deliverables",
                                    "kind": "LinkedHandle",
                                    "name": "deliverables"
                                },
                                {
                                    "alias": null,
                                    "args": (v16 /*: any*/),
                                    "concreteType": "PhaseTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "phases",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "PhaseTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "PhaseType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v6 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "startYear",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "startMonth",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "startDay",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "deadlineDay",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "deadlineMonth",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "deadlineYear",
                                                            "storageKey": null
                                                        },
                                                        (v17 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "RoleRate",
                                                            "kind": "LinkedField",
                                                            "name": "averageRatesByRole",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "roleId",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "costRate",
                                                                    "storageKey": null
                                                                },
                                                                (v10 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": (v21 /*: any*/),
                                                            "concreteType": "PhaseDeliverableTypeConnection",
                                                            "kind": "LinkedField",
                                                            "name": "phaseDeliverables",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "PhaseDeliverableTypeEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "PhaseDeliverable",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v4 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "phaseId",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "DeliverableType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "deliverable",
                                                                                    "plural": false,
                                                                                    "selections": (v22 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": (v11 /*: any*/),
                                                                                    "concreteType": "FinancialNumbers",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "financialNumbers",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v12 /*: any*/),
                                                                                        (v14 /*: any*/),
                                                                                        (v13 /*: any*/),
                                                                                        (v7 /*: any*/),
                                                                                        (v8 /*: any*/),
                                                                                        (v15 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": "financialNumbers(convertToProjectCurrency:true)"
                                                                                },
                                                                                (v18 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v19 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v20 /*: any*/)
                                                            ],
                                                            "storageKey": "phaseDeliverables(first:10000)"
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": (v21 /*: any*/),
                                                            "filters": [],
                                                            "handle": "connection",
                                                            "key": "Phase_phaseDeliverables",
                                                            "kind": "LinkedHandle",
                                                            "name": "phaseDeliverables"
                                                        },
                                                        (v18 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v19 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v20 /*: any*/)
                                    ],
                                    "storageKey": "phases(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v16 /*: any*/),
                                    "filters": [],
                                    "handle": "connection",
                                    "key": "Project_phases",
                                    "kind": "LinkedHandle",
                                    "name": "phases"
                                },
                                {
                                    "alias": null,
                                    "args": (v16 /*: any*/),
                                    "concreteType": "PhaseBaselineExpenseTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "phaseBaselineExpenses",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "PhaseBaselineExpenseTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "PhaseBaselineExpenseType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "expenseName",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ExpenseCategory",
                                                            "kind": "LinkedField",
                                                            "name": "expenseCategory",
                                                            "plural": false,
                                                            "selections": (v23 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "expenseRevenue",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "expenseCost",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "expenseMarkup",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "expenseProfit",
                                                            "storageKey": null
                                                        },
                                                        (v24 /*: any*/),
                                                        (v25 /*: any*/),
                                                        (v18 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v19 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v20 /*: any*/)
                                    ],
                                    "storageKey": "phaseBaselineExpenses(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v16 /*: any*/),
                                    "filters": [],
                                    "handle": "connection",
                                    "key": "Project_phaseBaselineExpenses",
                                    "kind": "LinkedHandle",
                                    "name": "phaseBaselineExpenses"
                                },
                                {
                                    "alias": null,
                                    "args": (v16 /*: any*/),
                                    "concreteType": "PhaseBaselineRoleTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "phaseBaselineRoles",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "PhaseBaselineRoleTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "PhaseBaselineRoleType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v24 /*: any*/),
                                                        (v25 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Role",
                                                            "kind": "LinkedField",
                                                            "name": "role",
                                                            "plural": false,
                                                            "selections": (v23 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": (v11 /*: any*/),
                                                            "concreteType": "FinancialNumbers",
                                                            "kind": "LinkedField",
                                                            "name": "financialNumbers",
                                                            "plural": false,
                                                            "selections": [
                                                                (v12 /*: any*/),
                                                                (v14 /*: any*/),
                                                                (v13 /*: any*/),
                                                                (v7 /*: any*/),
                                                                (v8 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "baselineRatePerHour",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "baselineCostPerHour",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": "financialNumbers(convertToProjectCurrency:true)"
                                                        },
                                                        (v18 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v19 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v20 /*: any*/)
                                    ],
                                    "storageKey": "phaseBaselineRoles(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v16 /*: any*/),
                                    "filters": [],
                                    "handle": "connection",
                                    "key": "Project_phaseBaselineRoles",
                                    "kind": "LinkedHandle",
                                    "name": "phaseBaselineRoles"
                                }
                            ],
                            "storageKey": null
                        },
                        (v4 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Company",
                            "kind": "LinkedField",
                            "name": "company",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/),
                                (v6 /*: any*/),
                                (v9 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RoleTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "roles",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RoleTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Role",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v22 /*: any*/),
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ExpenseCategoryTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "expenseCategories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ExpenseCategoryTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ExpenseCategory",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v6 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "disabled",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": null,
            "metadata": {},
            "name": "BaselineEditPageQuery",
            "operationKind": "query",
            "text": "query BaselineEditPageQuery(\n  $projectId: String\n) {\n  viewer {\n    actualPersonId\n    component(name: \"edit_baseline\")\n    project(id: $projectId) {\n      id\n    }\n    ...BaselineEditPage_viewer_2CgS8h\n    id\n  }\n}\n\nfragment BaselineEditPage_viewer_2CgS8h on Viewer {\n  id\n  company {\n    id\n    name\n    currency\n    roles {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n    expenseCategories {\n      edges {\n        node {\n          id\n          name\n          disabled\n        }\n      }\n    }\n  }\n  project(id: $projectId) {\n    ...ProjectIndicator_project\n    useBaseline\n    useDeliverables\n    budgetType\n    budget\n    id\n    status\n    companyProjectId\n    customProjectId\n    projectColor\n    name\n    baselineEstimationMinutesPerDay\n    projectStartYear\n    projectStartMonth\n    projectStartDay\n    projectEndYear\n    projectEndMonth\n    projectEndDay\n    baselineTargetMinutes\n    baselineTarget\n    baselineCost\n    baselineProfit\n    baselineAdjustPercentage\n    baselineAdjustPrice\n    baselineTargetPrice\n    useFixedPriceForBaselineRevenue\n    rateCard {\n      id\n      currency\n      disabledRoles {\n        id\n      }\n      rates {\n        edges {\n          node {\n            rate\n            defaultRate\n            role {\n              id\n            }\n            id\n          }\n        }\n      }\n    }\n    financialNumbers(convertToProjectCurrency: true) {\n      baselineMinutes\n      baselineRevenue\n      baselineTimeAndExpenses\n      baselineCost\n      baselineProfit\n      baselineMargin\n    }\n    deliverables(first: 1000000) {\n      edges {\n        node {\n          id\n          name\n          description\n          projectId\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    phases(first: 1000000) {\n      edges {\n        node {\n          id\n          name\n          startYear\n          startMonth\n          startDay\n          deadlineDay\n          deadlineMonth\n          deadlineYear\n          projectId\n          averageRatesByRole {\n            roleId\n            costRate\n            rate\n          }\n          phaseDeliverables(first: 10000) {\n            edges {\n              node {\n                id\n                phaseId\n                deliverable {\n                  id\n                  name\n                }\n                financialNumbers(convertToProjectCurrency: true) {\n                  baselineMinutes\n                  baselineTimeAndExpenses\n                  baselineRevenue\n                  baselineCost\n                  baselineProfit\n                  baselineMargin\n                }\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    phaseBaselineExpenses(first: 1000000) {\n      edges {\n        node {\n          id\n          expenseName\n          expenseCategory {\n            name\n            id\n          }\n          expenseRevenue\n          expenseCost\n          expenseMarkup\n          expenseProfit\n          globalPhaseId\n          deliverableId\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    phaseBaselineRoles(first: 1000000) {\n      edges {\n        node {\n          id\n          globalPhaseId\n          deliverableId\n          role {\n            name\n            id\n          }\n          financialNumbers(convertToProjectCurrency: true) {\n            baselineMinutes\n            baselineTimeAndExpenses\n            baselineRevenue\n            baselineCost\n            baselineProfit\n            baselineRatePerHour\n            baselineCostPerHour\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n\nfragment ProjectIndicator_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n"
        }
    };
})();
node.hash = '8fdb98b3a2002690c63b1d6f33df9b10';
export default node;
